import { useCatalogReportSettings } from "@ext/catalog/report/logic/useCatalogReportSettings";
import ViewActions from "@ext/markdown/elements/view/edit/components/Helpers/ViewActions";

export const CatalogReportActions = () => {
	const { settings, updateSettings, updateDisplay } = useCatalogReportSettings();

	return <ViewActions settings={settings} updateAttributes={updateSettings} updateDisplay={updateDisplay} />;
};
